const CrearIcono = (ClaseIcono) => <i className={ClaseIcono} aria-hidden="true" />;

export const getMenuItems = () => {
  return [
    {
      path: `${import.meta.env.BASE_URL}dashboard/resumen`,
      icon: CrearIcono('ti ti-layout-dashboard'),
      type: "link",
      selected: false,
      active: false,
      title: "Dashboard",
    },
    {
      icon: CrearIcono('ti ti-users'),
      type: "empty",
      selected: false,
      active: false,
      title: "Usuarios",
    },
    {
      path: `${import.meta.env.BASE_URL}configuracion/importar-clientes`,
      icon: CrearIcono('ti ti-database'),
      type: "link",
      selected: false,
      active: false,
      title: "Cargas de datos",
    },
    {
      icon: CrearIcono('ti ti-message-circle'),
      type: "empty",
      selected: false,
      active: false,
      title: "Consultas",
    },
    {
      path: `${import.meta.env.BASE_URL}automatizacion/campaigns`,
      icon: CrearIcono('ti ti-layers-subtract'),
      type: "link",
      selected: false,
      active: false,
      title: "Campañas",
    },
    {
      icon: CrearIcono('bi bi-tag'),
      type: "empty",
      selected: false,
      active: false,
      title: "Promociones",
    },
    {
      icon: CrearIcono('ti ti-chart-bar'),
      type: "empty",
      selected: false,
      active: false,
      title: "Reportes",
    },
    {
      icon: CrearIcono('bi bi-gear'),
      type: "empty",
      selected: false,
      active: false,
      title: "Configuración",
    },
  ];
};

export const MenuItems = getMenuItems();
